<template>
  <ion-app :dir>
    <Suspense>
      <router-view></router-view>
    </Suspense>
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp } from "@ionic/vue";
import { useI18n } from "vue-i18n";
import { useLocaleStore } from "./modules/locale/store/locale";
import { computed } from "vue";

const i18n = useI18n();
const localeStore = useLocaleStore();

const dir = computed(() => {
  const language = localeStore.availableLanguages.find(
    (lang) => lang.code === i18n.locale.value
  );
  return language?.dir === "rtl" ? "rtl" : "ltr";
});
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style scoped></style>
